module.exports = __webpack_public_path__ + "assets/images/ride-clean-up-6234c1a627f9ec0fdc893db5395f29c5.png";